import { render, staticRenderFns } from "./ProjectExplorer.vue?vue&type=template&id=3b2e4a54&scoped=true&"
import script from "./ProjectExplorer.vue?vue&type=script&lang=js&"
export * from "./ProjectExplorer.vue?vue&type=script&lang=js&"
import style0 from "./ProjectExplorer.vue?vue&type=style&index=0&id=3b2e4a54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2e4a54",
  null
  
)

export default component.exports